import { CHARGING_SESSION_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  ChargingSessionReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const chargingSessionReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CHARGING_SESSION_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case CHARGING_SESSION_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        ChargingSessionReport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case CHARGING_SESSION_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default chargingSessionReportReducer;
